import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi/useApi";
import { useNotification } from "~hooks/useNotification";
import type { DefaultOperationSuccessResponse } from "~types/response";
import type { UserTransformed } from "../types";

const useDeletePermissionUser = () => {
  const { sport, organizationId } = useParams();
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();
  const request = useApi();
  const notification = useNotification();

  return useMutation<DefaultOperationSuccessResponse, Error, number>({
    mutationFn: async (userId: number) => {
      return await request(`${sport}/o/${organizationId}/users/${userId}`, {
        method: "DELETE",
      });
    },
    onSuccess: (response: DefaultOperationSuccessResponse, userId: number) => {
      if (response?.data[0]?.success) {
        queryClient.setQueryData<UserTransformed[] | undefined>(["permission-users", sport, organizationId], (oldData) => {
          return oldData?.filter((item: UserTransformed) => item?.userId !== userId) || [];
        });
        notification.success({
          message: formatMessage({
            id: "permissions.user.actions.delete.success",
          }),
          placement: "bottomRight",
        });
      }
    },
  });
};

export default useDeletePermissionUser;
